import instanciaAxios from './InterceptorAxios';

const servicioBitacora = {

   
    buscarUsuario(usuario){
        return instanciaAxios.post('usuario/buscar_usuario.json',{usuario:usuario});
    }

}

export default servicioBitacora;